import { Button } from '@mantine/core'
import { useRouter } from 'next/router'
import { useState, useEffect } from 'react'

import { useTranslation } from '@flecto/translations'
import { type CoreCustomer } from '@flecto/types'
import { Drawer } from '@flecto/ui'

import { FormCustomer } from '../FormCustomer/FormCustomer'
import { useDrawerCustomer } from './useDrawerCustomer'
export type DrawerCustomerProps = {
  customer?: Partial<CoreCustomer>
  setCustomer?: (customer: Partial<CoreCustomer> | undefined) => void
}
export function DrawerCustomer({ customer, setCustomer }: DrawerCustomerProps) {
  const router = useRouter()
  const { t } = useTranslation('saas', { keyPrefix: 'customers' })
  const [isLoading, setIsLoading] = useState(false)
  const { closeDrawer } = useDrawerCustomer()
  const handleClose = () => {
    setCustomer?.(undefined)
    closeDrawer()
  }
  const title = customer ? customer?.full_name : t('title')

  useEffect(() => {
    if (router?.events) {
      router.events.on('routeChangeStart', handleClose)
      return () => {
        router.events.off('routeChangeStart', handleClose)
      }
    }
  }, [router.events])

  return (
    <Drawer withContainer>
      <Drawer.Close onClick={handleClose} />
      <Drawer.Title>{title}</Drawer.Title>
      <Drawer.Actions>
        <Button type='submit' form='customer-form' loading={isLoading}>
          {t('save')}
        </Button>
      </Drawer.Actions>
      <Drawer.Content>
        <FormCustomer
          id='customer-form'
          initialCustomer={customer as Partial<CoreCustomer>}
          onSuccess={handleClose}
          onChangeLoading={setIsLoading}
          setCustomer={setCustomer}
          hideSections={['verify']}
        />
      </Drawer.Content>
    </Drawer>
  )
}
